import React, { Dispatch, SetStateAction, useState } from 'react';
import Navigator from './components/Navigation';
import LifeTodoToggle from './components/LifeTodoToggle';
import { useMetaTags } from './utils/useMetaTags';
import pairsData from './data/englishPairs.json';
import './font.css';
import './style.css';

type Pair = { ko: string; en: string; source?: string };

const pairs: Pair[] = pairsData as Pair[];

function pickRandomPair(exclude?: Pair | null): Pair | null {
  if (pairs.length === 0) return null;
  if (pairs.length === 1) return pairs[0];
  let next = pairs[Math.floor(Math.random() * pairs.length)];
  // 연달아 같은 페어가 뽑히면 한 번 더 시도 (전체가 2개 이상일 때만 의미 있음)
  while (exclude && next === exclude) {
    next = pairs[Math.floor(Math.random() * pairs.length)];
  }
  return next;
}

function PageEnglish(props: {
  activeNav: number;
  setActiveNav: Dispatch<SetStateAction<number>>;
}) {
  useMetaTags({
    title: 'English - Lynkim',
    description: 'English',
    image: '/ogimage.png',
  });

  const [pair, setPair] = useState<Pair | null>(() => pickRandomPair());
  const handleNext = () => setPair((prev) => pickRandomPair(prev));

  return (
    <div>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='pageTitle'>English</div>
      <div
        style={{
          maxWidth: 720,
          margin: '0 auto',
          padding: '24px 20px 120px',
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
        }}
      >
        {pair ? (
          <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                type='button'
                onClick={handleNext}
                style={{
                  padding: '12px 28px',
                  border: '1px solid var(--color-text-primary)',
                  borderRadius: 999,
                  background: 'transparent',
                  color: 'var(--color-text-primary)',
                  fontSize: 15,
                  fontWeight: 500,
                  cursor: 'pointer',
                }}
              >
                다음
              </button>
            </div>
            <p
              style={{
                fontSize: 22,
                lineHeight: 1.6,
                margin: 0,
                color: 'var(--color-text-primary)',
                fontWeight: 500,
              }}
            >
              {pair.ko}
            </p>
            <p
              style={{
                fontSize: 18,
                lineHeight: 1.6,
                margin: 0,
                color: 'var(--color-text-secondary, #666)',
              }}
            >
              {pair.en}
            </p>
          </>
        ) : (
          <p style={{ color: 'var(--color-text-secondary, #666)' }}>
            아직 학습할 문장이 없어요.
          </p>
        )}
      </div>
      <LifeTodoToggle />
    </div>
  );
}

export default PageEnglish;
